import React, { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalState";

import { Link } from "react-router-dom";
import "./ResimEkle.css";

function ResimEkle() {
  const {
    //RAPORDA KULLANILACAK

    setKonumResim,

    setBirinciResim,

    setIkinciResim,
    //ÖNİZLEMEDE KULLANILACAK
    //ÖNİZLEME RESİMLER
    konumResmiOnizleme,
    setKonumResmiOnizleme,
    birinciResmiOnizleme,
    setBirinciResmiOnizleme,
    ikinciResmiOnizleme,
    setIkinciResmiOnizleme,
  } = useContext(GlobalContext);

  // Dosya seçildiğinde çalışacak fonksiyon
  const konumResmiAyarla = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1]; // Base64 kısmını alıyoruz
      setKonumResim(base64String);
      setKonumResmiOnizleme(reader.result); // Görseli göstermek için base64'ü saklıyoruz
    };

    if (file) {
      reader.readAsDataURL(file); // Dosyayı Base64 olarak okuyoruz
    }
  };

  const birinciResmiAyarla = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1]; // Base64 kısmını alıyoruz
      setBirinciResim(base64String);
      setBirinciResmiOnizleme(reader.result); // Görseli göstermek için base64'ü saklıyoruz
    };

    if (file) {
      reader.readAsDataURL(file); // Dosyayı Base64 olarak okuyoruz
    }
  };

  const ikinciResmiAyarla = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1]; // Base64 kısmını alıyoruz
      setIkinciResim(base64String);
      setIkinciResmiOnizleme(reader.result); // Görseli göstermek için base64'ü saklıyoruz
    };

    if (file) {
      reader.readAsDataURL(file); // Dosyayı Base64 olarak okuyoruz
    }
  };

  return (
    <div className="App">
      {/* <div className="container">
        <div className="row">
          <div className="col my-3">
            <h2>Konum Resmi Seçiniz</h2>
            <input name="konum" type="file" onChange={konumResmiAyarla} />
            {konumResmiOnizleme && (
              <div>
                <img
                  name="konum"
                  src={konumResmiOnizleme}
                  alt="Yüklenen raporKonumResim"
                  style={{ maxWidth: "300px" }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col my-3">
            <h2>Taşınmaz Resmi Seçiniz</h2>
            <input
              name="birinciresim"
              type="file"
              onChange={birinciResmiAyarla}
            />
            {birinciResmiOnizleme && (
              <div>
                <img
                  name="birinciresim"
                  src={birinciResmiOnizleme}
                  alt="Yüklenen Birinci Resim"
                  style={{ maxWidth: "300px" }}
                />
              </div>
            )}
          </div>
          <div className="col my-3">
            <h2>Taşınmaz Resmi Seçiniz</h2>
            <input
              name="ikinciresim"
              type="file"
              onChange={ikinciResmiAyarla}
            />
            {ikinciResmiOnizleme && (
              <div>
                <img
                  name="ikinciresim"
                  src={ikinciResmiOnizleme}
                  alt="Yüklenen İkinci Resim"
                  style={{ maxWidth: "300px" }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <Link to="/agacdegerleme">
              <button className="btn btn-success btn-lg mt-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-left-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                  />
                </svg>{" "}
                Ağaç Değerleme
              </button>
            </Link>
          </div>
          <div className="col-3"></div>
          <div className="col-3"></div>
          <div className="col-3">
            <Link to="/raporozet">
              <button className="btn btn-primary btn-lg mt-5">
                Rapor Özeti{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-right-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                  />
                </svg>
              </button>
            </Link>
          </div>
        </div>
      </div> */}
      <div className="container">
        <div className="row">
          <div className="col my-3">
            <h2>Konum Resmi Seçiniz</h2>

            {konumResmiOnizleme && (
              <div className="preview-container">
                <img
                  name="konum"
                  src={konumResmiOnizleme}
                  alt="Yüklenen Konum Resmi"
                />
              </div>
            )}
            <label htmlFor="konumResmi" className="custom-file-upload my-2">
              Resim Yükle
              <input
                id="konumResmi"
                name="konum"
                type="file"
                accept="image/*"
                onChange={konumResmiAyarla}
                style={{ display: "none" }}
              />
            </label>
          </div>
        </div>
        <div className="row">
          <div className="col my-3">
            <h2>Birinci Resmi Seçiniz</h2>

            {birinciResmiOnizleme && (
              <div className="preview-container">
                <img
                  name="birinciresim"
                  src={birinciResmiOnizleme}
                  alt="Yüklenen Birinci Resim"
                />
              </div>
            )}
            <label htmlFor="birinciResim" className="custom-file-upload my-2">
              Resim Yükle
              <input
                id="birinciResim"
                name="birinciresim"
                type="file"
                onChange={birinciResmiAyarla}
                style={{ display: "none" }}
              />
            </label>
          </div>
          <div className="col my-3">
            <h2>İkinci Resmi Seçiniz</h2>

            {ikinciResmiOnizleme && (
              <div className="preview-container">
                <img
                  name="ikinciresim"
                  src={ikinciResmiOnizleme}
                  alt="Yüklenen İkinci Resim"
                />
              </div>
            )}
            <label htmlFor="ikinciResim" className="custom-file-upload my-2">
              Resim Yükle
              <input
                id="ikinciResim"
                name="ikinciresim"
                type="file"
                onChange={ikinciResmiAyarla}
                style={{ display: "none" }}
              />
            </label>
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <Link to="/agacdegerleme">
              <button className="btn btn-success btn-lg mt-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-left-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                  />
                </svg>{" "}
                Ağaç Değerleme
              </button>
            </Link>
          </div>
          <div className="col-3"></div>
          <div className="col-3"></div>
          <div className="col-3">
            <Link to="/raporozet">
              <button className="btn btn-primary btn-lg mt-5">
                Rapor Özeti{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-right-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                  />
                </svg>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResimEkle;
